// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SocialFb: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fillRule="evenodd" d="M26.8 20.6V18c0-1 .6-1.2 1.1-1.2h2.7v-4.2h-3.8c-4.2 0-5.2 3.1-5.2 5.2v2.8h-2.4v4.3h2.4v12.4h5.1V25h3.4l.4-4.3h-3.7v-.1z" clipRule="evenodd"/></svg>;
};

export default React.memo(SocialFb);
